interface IChatMessageAttachmentProps {
  id: number;
  fileUrl: string;
  thumbnailUrl: string | null;
  type: string;
  fileName: string;
  fileExtension: string | null;
}

export class MChatMessageAttachment {
  props: IChatMessageAttachmentProps;

  constructor(props: IChatMessageAttachmentProps) {
    this.props = props;
  }

  get isFile() {
    return this.props.type === 'file';
  }

  get isImage() {
    return this.props.type === 'image';
  }
}
